'use client'

import { Button } from '@repo/design-system-cf/components/button'
import { IconChat } from '@repo/design-system-cf/components/icons'
import { tw } from 'utils/classnames'

export function CommentButton({
  commentCount,
  size = 'small',
  onClick,
  isButton = true,
}: {
  commentCount: number
  size?: 'small' | 'regular'
  onClick?: () => void
  isButton?: boolean
}) {
  return isButton ? (
    <Button
      variant="ghost"
      size={'small'}
      onClick={() => onClick?.()}
      className={tw(
        'text-cf-violet border font-medium border-[#1313151F] flex gap-1 w-auto bg-cf-grey-50 flex-row items-center p-0 !px-2.5 rounded-[40px] hover:bg-cf-grey-200 hover:text-cf-violet',

        size === 'regular' ? 'h-[32px] !px-3 text-16' : 'h-[26px] !px-2.5 text-14',
      )}
      data-testid="clubhouse-discussion-comments-button"
      iconLeft={<IconChat className={tw(size === 'regular' ? '!size-5' : '!size-4 mt-0.5')} />}
    >
      {commentCount}
    </Button>
  ) : (
    <div
      onClick={() => onClick?.()}
      className={tw(
        'text-cf-violet border font-medium border-[#1313151F] flex gap-1 w-auto bg-cf-grey-50 flex-row items-center p-0 !px-2.5 rounded-[40px] hover:bg-cf-grey-200 hover:text-cf-violet',

        size === 'regular' ? 'h-[32px] !px-3 text-16' : 'h-[26px] !px-2.5 text-14',
      )}
      data-testid="clubhouse-discussion-comments-button"
    >
      <IconChat className={tw(size === 'regular' ? '!size-5' : '!size-4 mt-0.5')} />
      {commentCount}
    </div>
  )
}
